import {nanoid} from "nanoid";

import {ImageAttrs, ImageNode} from "../../module/schema";


import {schema} from "../../module/config/schema";


export const createImageNode = (s3FileName: string) => {
    return schema.node("image", {s3FileName: s3FileName, guid: nanoid(6)});
}

export const createImageUploadingPlaceholder = (file: File) => {
    const localUrl = URL.createObjectURL(file); // blob:https://localhost...
    return schema.node(
        "image",
        {
            src: localUrl,
            guid: nanoid(6),
        }
    ) as ImageNode;
}

export const copyImageNode = (node: ImageNode, attributesOverride: Partial<ImageAttrs> = {}) => {
    return schema.nodes.image.create(
        {
            ...node.attrs,
            guid: nanoid(6),
            ...attributesOverride,
        },
        node.content,
        node.marks,
    ) as ImageNode
}